import React from 'react';
import { View, colors } from '@fairygodboss/ui';
import ReactionBar from '../../../../ReactionBar/ReactionBar';

const buttonLabelStyle = {
    fontFamily: 'Open Sans',
    textTransform: 'capitalize',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '18px',
    letterSpacing: '-0.4px',
    color: colors.secondary[40],
};

export const CommentReactionBar = ({ hash, onCommentClick }) => {
    return (
        <View
            display="flex"
            pb="16px"
            css={{
                '.wrap-auth-div': {
                    marginLeft: '8px !important',
                },
                button: {
                    height: '28px',
                },
                '.component-Community-ReactionBar-CommunityLikeButton': {
                    '@media (hover: hover)': {
                        ':hover': {
                            svg: {
                                path: {
                                    fill: `${colors.secondary[20]} !important`,
                                },
                            },
                        },
                    },
                    '.button-label': {
                        ...buttonLabelStyle,
                    },
                    svg: {
                        height: '24px',
                        width: '22px',
                        marginRight: '8px',
                        path: {
                            fill: `${colors.secondary[40]} !important`,
                        },
                        '&.active': {
                            path: {
                                fill: '#982fa8 !important',
                            },
                        },
                    },
                },
                '.component-Community-ReactionBar-CommunityCommentButton': {
                    '@media (hover: hover)': {
                        ':hover': {
                            svg: {
                                path: {
                                    stroke: colors.secondary[20],
                                },
                            },
                        },
                    },
                    svg: {
                        height: '36px',
                        width: '48px',
                        position: 'relative',
                        top: '7px',
                        left: '4px',
                        path: {
                            stroke: colors.secondary[40],
                            strokeWidth: '1.5',
                            fill: 'none',
                        },
                    },
                    '.button-label': {
                        ...buttonLabelStyle,
                        marginBottom: '2px',
                    },
                },
            }}
        >
            <ReactionBar
                hash={hash}
                showLikeLabel
                onCommentClick={() => onCommentClick()}
            />
        </View>
    );
};
